import { useEffect } from 'react';
import type { FlyToOptions } from '@elfsight/widget-map';
import { MapComponent } from '@elfsight/widget-map';
import { useSettings } from '@wu/widget-core';
import { useActiveLocation } from '../active-location-context';
import { useMapAPI } from '../map-api-context';

export const Map = ({ flyToOptions }: { flyToOptions?: FlyToOptions }) => {
  const {
    mapColorScheme,
    mapMarkerColor,
    mapMarkerIcon,
    mapCenterType,
    mapCenterValue,
    mapZoomValue,
    mapZoomType,
    language,
    widgetToken
  } = useSettings();
  const { setActiveLocation } = useActiveLocation();
  const { points, setMapAPI, mapAPIRef } = useMapAPI();

  const { language: locale } = language ?? {};

  const zoomValue = mapZoomType === 'auto' ? 'auto' : mapZoomValue;
  const centerValue =
    mapCenterType === 'auto' ? 'auto' : mapCenterValue?.coordinates;

  useEffect(() => {
    mapAPIRef?.current?.onMarkerClick(setActiveLocation, 'map-component');
  }, [setActiveLocation]);

  return (
    <MapComponent
      center={centerValue}
      ref={setMapAPI}
      zoom={zoomValue}
      mapStyle={mapColorScheme}
      points={points}
      locale={locale}
      markerColor={mapMarkerColor}
      markerIconUrl={mapMarkerIcon?.url}
      flyToOptions={flyToOptions}
      widgetToken={widgetToken}
    />
  );
};
